module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("表单与输入")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("表单 - <uk-form>")]), _vm._v(" "), _c('uk-form', {
    attrs: {
      "stacked": _vm.formStacked,
      "horizontal": _vm.formHorizontal
    }
  }, [_c('uk-field', {
    attrs: {
      "name": "username",
      "label": "用户",
      "icon": "user"
    }
  }, [_c('uk-input', {
    attrs: {
      "name": "username",
      "id": "username"
    }
  })], 1), _vm._v(" "), _c('uk-field', {
    attrs: {
      "name": "github",
      "label": "Github",
      "icon": "github"
    }
  }, [_c('uk-input', {
    attrs: {
      "name": "github",
      "id": "github"
    }
  })], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("<uk-form> 属性")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-striped uk-table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('td', [_vm._v("堆叠布局")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formStacked),
      expression: "formStacked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formStacked) ? _vm._i(_vm.formStacked, null) > -1 : (_vm.formStacked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formStacked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.formStacked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formStacked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formStacked = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('td', [_vm._v("垂直布局")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formHorizontal),
      expression: "formHorizontal"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formHorizontal) ? _vm._i(_vm.formHorizontal, null) > -1 : (_vm.formHorizontal)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formHorizontal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.formHorizontal = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formHorizontal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formHorizontal = $$c
        }
      }
    }
  })])])])]), _vm._v(" "), _c('uk-alert', [_vm._v("\n    <uk-field>是一个 form 内的输出控件行部布的子控件。可以大量简化form内的代码。\n  ")]), _vm._v(" "), _c('p', [_c('code-block', [_vm._v(_vm._s(_vm.usages.form))])], 1), _vm._v(" "), _c('h2', [_vm._v("密码输入框 - <uk-password> ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "uk-form"
  }, [_c('uk-password', {
    attrs: {
      "name": "user-password",
      "show-label": _vm.showLabel,
      "hide-label": _vm.hideLabel
    }
  })], 1), _vm._v(" "), _c('p', [_c('code-block', [_vm._v(_vm._s(_vm.usages.pwd))])], 1), _vm._v(" "), _c('h3', [_vm._v("属性")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-striped uk-table-condensed"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('td', [_vm._v("\"显示密码\"时显示的文字")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showLabel),
      expression: "showLabel"
    }],
    staticClass: "uk-width-1-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.showLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.showLabel = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('td', [_vm._v("\"隐藏密码\"时显示的文字")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hideLabel),
      expression: "hideLabel"
    }],
    staticClass: "uk-width-1-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.hideLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hideLabel = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('h2', [_vm._v("只读选项 - <uk-select>")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "uk-form"
  }, [_c('uk-select', {
    attrs: {
      "items": ['选项1', '选项2', '选项3', '选项4', '选项5']
    }
  })], 1), _vm._v(" "), _c('p', [_c('code-block', [_vm._v(_vm._s(_vm.usages.select))])], 1), _vm._v(" "), _c('h2', [_vm._v("进度条 - <uk-progress>")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("示例")]), _vm._v(" "), _c('p', [_c('uk-progress', {
    attrs: {
      "striped": _vm.striped,
      "show-value": _vm.showValue,
      "size": _vm.size,
      "color": _vm.color,
      "value": _vm.percent
    }
  })], 1), _vm._v(" "), _c('p', [_c('code-block', [_vm._v(_vm._s(_vm.usages.progress))])], 1), _vm._v(" "), _c('h3', [_vm._v("属性")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-striped uk-table-condensed"
  }, [_vm._m(14), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('td', [_vm._v("只能从0~100之间取值")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percent),
      expression: "percent"
    }],
    staticClass: "uk-width-1-1",
    attrs: {
      "min": "0",
      "max": "100",
      "type": "number"
    },
    domProps: {
      "value": _vm._s(_vm.percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.percent = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('td', [_vm._v("颜色")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.color),
      expression: "color"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.color = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("success")]), _vm._v(" "), _c('option', [_vm._v("warning")]), _vm._v(" "), _c('option', [_vm._v("danger")])])])]), _vm._v(" "), _c('tr', [_vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('td', [_vm._v("尺寸")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.size),
      expression: "size"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.size = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("undefined")]), _vm._v(" "), _c('option', [_vm._v("mini")]), _vm._v(" "), _c('option', [_vm._v("small")])])])]), _vm._v(" "), _c('tr', [_vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showValue),
      expression: "showValue"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showValue) ? _vm._i(_vm.showValue, null) > -1 : (_vm.showValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.showValue = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.showValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showValue = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.striped),
      expression: "striped"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.striped) ? _vm._i(_vm.striped, null) > -1 : (_vm.striped)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.striped,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.striped = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.striped = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.striped = $$c
        }
      }
    }
  })])])])]), _vm._v(" "), _c('h2', [_vm._v("带图标的输入字段 <uk-icon-field>")]), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "uk-form"
  }, [_c('uk-icon-field', {
    attrs: {
      "icon": "calendar"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', {
    staticClass: "uk-width-2-6"
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("体验")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("stacked")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("horizontal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', {
    staticClass: "uk-width-2-6"
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("体验")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("showLabel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("hideLabel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', {
    staticClass: "uk-width-2-6"
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("体验")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("showValue")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("striped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    这是一个包装控件，它的用法与 "), _c('code', [_vm._v("<uk-icon>")]), _vm._v("类似，它只有一个"), _c('code', [_vm._v("icon")]), _vm._v("属性，而默认插槽内直接放置输入控件就会自动在输入控件的左端放入一个图标。\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15b0d062!./~/vue-loader/lib/selector.js?type=template&index=0!./src/docs/Forms.vue
// module id = 279
// module chunks = 2